import {CSSProperties, ReactNode, useCallback} from 'react';
import {Range} from 'rc-slider';
import {FilterRange} from '../../utils';
import ShopFilterToggleContainer from './ShopFilterToggleContainer.client';

interface ShopFilterSliderProps {
  title: string;
  min: number;
  max: number;
  name: string;
  onSlide: (values: FilterRange, name: string) => void;
  children: ReactNode | Array<ReactNode>;
  value: FilterRange;
}

export default function ShopFilterSlider({
  title,
  min,
  max,
  name,
  onSlide,
  children,
  value,
}: ShopFilterSliderProps) {
  const slideHandler = useCallback(
    (value: number[]) => {
      onSlide({min: value[0], max: value[1]}, name);
    },
    [name, onSlide],
  );

  const handleStyle: CSSProperties = {
    width: '21px',
    height: '21px',
    top: '2px',
    border: 'solid 4px #f73400',
    borderRadius: '50%',
    backgroundColor: '#fff',
    boxShadow: 'none',
    cursor: 'pointer',
  };
  const trackStyle: CSSProperties = {
    height: '6px',
    border: 'none',
    boxShadow: 'none',
    backgroundColor: '#f73400',
  };
  const railStyle: CSSProperties = {
    ...trackStyle,
    backgroundColor: '#d8d8d8',
  };

  return (
    <ShopFilterToggleContainer
      title={title}
      contentClassName="shop-filter__contents-range mt-20"
    >
      <Range
        className="shop-filter__rc-range-slider"
        onChange={slideHandler}
        allowCross={false}
        value={[value.min, value.max]}
        min={min}
        max={max}
        ariaLabelGroupForHandles={['min slider handle', 'max slider handle']}
        handleStyle={[handleStyle, handleStyle]}
        trackStyle={[trackStyle]}
        railStyle={railStyle}
      />
      {children}
    </ShopFilterToggleContainer>
  );
}
